import { render, staticRenderFns } from "./WordDict_m.vue?vue&type=template&id=e7740b44&scoped=true&"
import script from "./WordDict_m.vue?vue&type=script&lang=js&"
export * from "./WordDict_m.vue?vue&type=script&lang=js&"
import style0 from "./WordDict_m.vue?vue&type=style&index=0&id=e7740b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7740b44",
  null
  
)

export default component.exports